import React from "react"
import RcmpLink from "../Link";

import styles from './index.module.scss';

function RcmpItem(props) {
    const { bActive, children, ...oRest } = props;

    if (bActive) {
        return (
            <p
                className={`${styles.breadCrumbItem} ${styles.breadCrumbActiveItem}`}
                {...oRest}>
                {children}
            </p>
        )
    }

    return (
        <RcmpLink className={styles.breadCrumbItem} {...oRest}>
            {children}
        </RcmpLink>
    );
}

function RcmpMainBreadCrumb(props) {
    const { children, className, ...oRest } = props;

    const nTotalChidrens = React.Children.toArray(children)?.length

    const classes = `${styles.breadCrumbContainer} ${className ? className : ""}`

    return (
        <div className={classes} {...oRest}>
            {React.Children.map(children, (c, nIndex) => (
                <>
                    {React.cloneElement(c)}
                    {(nTotalChidrens > (nIndex + 1)) && (<p>{">"}</p>)}
                </>
            ))}
        </div>
    );
}

const RcmpBreadCrumb = Object.assign(RcmpMainBreadCrumb, { RcmpItem })


export default RcmpBreadCrumb;